<template>
    <div class="products view-container">
        <div class="view-content">
            <ActionBar title="Nossos Produtos" />

            <div v-if="loading" class="products-content">
                <v-skeleton-loader
                    v-for="n in 6"
                    :key="n"
                    class="skeleton empty_card experts"
                    type="image"
                    width="330"
                    height="280"
                />
            </div>

            <div v-else class="products-content">
                <div v-for="(product, index) in products" :key="index">
                    <ProductCard :data="product" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { mainStore } from '../store'

import ActionBar from '../components/ActionBar.vue'
import ProductCard from '../components/cards/ProductCard.vue'

import request from '../common/request'

const store = mainStore()

const loading = ref(true)

const products = computed(() => store.products)

onMounted(() => {
    request
        .fetch({ collection: 'products' })
        .catch(console.error)
        .finally(() => (loading.value = false))
})
</script>

<style lang="scss">
.products {
    .products-content {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
    }

    .skeleton {
        margin: 0 24px 50px 0;
    }
}
</style>
